module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-03-5f495e1b12eb5acd65a9256dd76caf79.png";